import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import helpers from "../../../utils/helpers";
import { constants } from '../../../utils/constants';
import { IErrorAlert } from '../../../interfaces/error.interface';
import { ModalService } from '../../../services/modal.service';
import { RequestModel } from '../../../models/request.model';
import { Receipt } from '../../../models/receipt.model';
import Swal from 'sweetalert2';
import { RequestService } from '../../../services/request.service';
import { AuthService } from '../../../services/auth.service';



@Component({
  selector: 'app-receipt-management',
  templateUrl: './receipt-management.component.html',
  styleUrls: ['./receipt-management.component.css']
})
export class ReceiptManagementComponent implements OnInit {
  
  @Input() request: RequestModel;
  @Output() error: EventEmitter<IErrorAlert> = new EventEmitter();
  errorReceip: EventEmitter<IErrorAlert> = new EventEmitter();
  @Output() loading: EventEmitter<boolean> = new EventEmitter();
  
  maxReceipts = 5;
  
  constructor(public _modal: ModalService, public _request: RequestService, public _auth: AuthService) { }

  ngOnInit(): void {
    
  }

  checkMaxReceipts() {

   
    if (this.request.receipts?.length == this.maxReceipts) {
      this.error.emit(constants.alerts.receipts.maxReceipts);
      
    }
    
  }

  onFileSelected(file) {
   
    if (this.validateFile(file)) {
      const receipt = new Receipt({ file })
      this.error.emit(null);
      this._modal.show('CREATE', receipt, this.request)
    }
  }

  //Validations
  private validateFile(file: File): boolean {


    if (helpers.oversizeFile(file, 1)) {
      
      this.error.emit(constants.alerts.receipts.oversizeFile);
      return false;
    }
    if (!helpers.isPdf(file)) {
      this.error.emit(constants.alerts.receipts.invalidExtension);
      return false;
    }

    if (!helpers.isPdfEmpty(file)) {
      
      this.error.emit(constants.alerts.receipts.emptyFile);
      return false;
    }

    
    return true;
  }

  delete(receipt: Receipt) {
    this.showDeleteAlert(receipt).then((confirmed: boolean) => {
      if (confirmed) {
        this._request.deleteReceipt(receipt).subscribe(
          () => {
            this.request.deleteReceipt(receipt);
          },
          (err: IErrorAlert) => {
            this.error.emit({...err, width: 'auto'})
          }
        );
      }
    });
  }

  showDeleteAlert(receipt: Receipt): Promise<boolean> {
    return Swal.fire({
      html:
        "<p class='alert-question'>¿Estás seguro de eliminar el siguiente comprobante?</p>" +
        `<h3>${ receipt.name }</h3>`,
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
      showCloseButton: true,
      showClass: {
        popup: "animated fadeIn fast",
      },
      hideClass: {
        popup: "animated fadeOut fast",
      },
      customClass: {
        confirmButton: "confirm-button-class",
        cancelButton: "cancel-button-class",
        closeButton: "close-button-class",
      },
    }).then((result) => (result.value ? true : false));
  }

}
